import { PATHS } from '../../Config/Routing/paths'
import { ACTION_EDIT } from '../../constants'
import { CONFIG } from '../../Config/config'

const id = obj => (typeof obj === 'object' ? obj.id : obj)

/**
 * Generate a link to platform-next
 * Cookies are shared via parent domain (.oppizi.com or .promofy.marketing)
 * @param {string} path - The path on platform-next (e.g., '/dashboard/campaigns/123')
 * @returns {string} - Full URL to platform-next
 */
const getNextLink = path => {
  return `${CONFIG.NEXT_BASE_URL}${path}`
}

const getRosterLink = (campaign, cityPlan, roster, action) => {
  const link = [
    `${PATHS.main.dashboard}`,
    `${PATHS.dashboard.campaigns}/${id(campaign)}`,
    `/city-plans/${id(cityPlan)}`,
    `/rosters/${id(roster)}`,
  ].join('')

  return addAction(link, action)
}

const getCampaignsLink = action => {
  const link = [`${PATHS.main.dashboard}`, `${PATHS.dashboard.campaigns}`].join(
    '',
  )

  return addAction(link, action)
}

const getCampaignLink = (campaign, action) => {
  const link = [
    `${PATHS.main.dashboard}`,
    `${PATHS.dashboard.campaigns}/${id(campaign)}`,
  ]

  if (!action) {
    link.push('/city-plans')
  }

  return addAction(link.join(''), action)
}

const getCityPlanLink = (campaign, cityPlan, action) => {
  const link = [
    `${PATHS.main.dashboard}`,
    `${PATHS.dashboard.campaigns}/${id(campaign)}`,
    `/city-plans/${id(cityPlan)}`,
  ].join('')

  return addAction(link, action)
}

const addAction = (link, action) => {
  if (action === ACTION_EDIT) return `${link}/edit`
  return link
}

const getMissionLink = (campaign, cityPlan, roster, mission, action) => {
  const link = [
    `${PATHS.main.dashboard}`,
    `${PATHS.dashboard.campaigns}/${id(campaign)}`,
    `/city-plans/${id(cityPlan)}`,
    `/rosters/${id(roster)}`,
    `/missions/${id(mission)}`,
  ].join('')

  return addAction(link, action)
}

const getAmbassadorsLink = (ambassador, action) => {
  const { city } = ambassador

  const link = [
    `${PATHS.main.dashboard}`,
    `${PATHS.dashboard.cities}/${id(city)}/ambassadors`,
  ]

  return addAction(link.join(''), action)
}

const getAmbassadorLink = (cityId, ambassadorId) => {
  return `${PATHS.main.dashboard}${
    PATHS.dashboard.cities
  }/${cityId}/ambassadors/${ambassadorId}`
}

const getCityLink = (city, action) => {
  const link = [
    `${PATHS.main.dashboard}`,
    `${PATHS.dashboard.cities}/${id(city)}`,
  ]

  if (!action) {
    link.push('/locations')
  }

  return addAction(link.join(''), action)
}

const getSimpleMissionLink = missionId =>
  `${PATHS.main.dashboard}/mission/${missionId}`

const getLocationProfileLink = (cityId, locationId) =>
  getNextLink(
    `${PATHS.main.dashboard}${PATHS.dashboard.cities}/${cityId}${
      PATHS.cities.locations
    }/${locationId}`,
  )

export {
  getAmbassadorsLink,
  getAmbassadorLink,
  getCampaignsLink,
  getCampaignLink,
  getCityPlanLink,
  getMissionLink,
  getRosterLink,
  getCityLink,
  getSimpleMissionLink,
  getLocationProfileLink,
  getNextLink,
}
